import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('onpoint_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refreshToken = localStorage.getItem('onpoint_refresh');
      if (refreshToken) {
        try {
          const res = await axios.post(`${API_URL}/api/auth/refresh`, { refresh_token: refreshToken });
          const { access_token, refresh_token } = res.data;
          localStorage.setItem('onpoint_token', access_token);
          localStorage.setItem('onpoint_refresh', refresh_token);
          original.headers.Authorization = `Bearer ${access_token}`;
          return api.request(original);
        } catch {
          localStorage.removeItem('onpoint_token');
          localStorage.removeItem('onpoint_refresh');
          window.location.href = '/login';
        }
      } else {
        localStorage.removeItem('onpoint_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
